import { Spacings, View } from "react-native-ui-lib";
import { Text } from "@towersystems/roam-common-native";

export interface EmptyListProps {
  title?: string;
  description?: string;
  style?: any;
}

const DEFAULT_TITLE = "Empty List!";
const DEFAULT_DESCRIPTION = "No items found at this moment.";

export const EmptyList = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  style,
}: EmptyListProps) => {
  return (
    <View style={[{ alignItems: "center", paddingTop: Spacings.s5 }, style]}>
      <Text variant="heading3" fontWeight="bold" center>
        {title}
      </Text>
      <Text style={{ marginTop: Spacings.s1 }} variant="body" center>
        {description}
      </Text>
    </View>
  );
};
